import {ApiService} from "./api.service";

export class SubscriptionService extends ApiService{
  constructor(organizationId) {
    super();
    this.endpoint = `/organizations/${organizationId}/subscriptions`;
    this.per = 10;
  }

  async initSubscriptionIntent(params){
    try {
      let url = `${this.endpoint}/subscription_intent`;
      let response = await this.post(url, params);
      if (response.status === 422 && response.json?.alert) {
        return { error: response.json.alert };
      }
      return response.json;
    } catch {
      return {"error": "error loading donation form"};
    }
  }

  async confirmPayment(subscriptionId, params){
    try {
      let url = `${this.endpoint}/${subscriptionId}/confirm`;
      let response = await this.post(url, params);
      return response.json;
    } catch {
      return null;
    }
  }

  async cancelSubscription(subscriptionId) {
    try {
      let url = `${this.endpoint}/${subscriptionId}/cancel_subscription`;
      return await this.post(url);
    } catch {
      return null;
    }
  }

  async pauseSubscription(subscriptionId) {
    try {
      let url = `${this.endpoint}/${subscriptionId}/pause_subscription`;
      return await this.post(url);
    } catch {
      return null;
    }
  }

  async resumeSubscription(subscriptionId) {
    try {
      let url = `${this.endpoint}/${subscriptionId}/resume_subscription`;
      return await this.post(url);
    } catch {
      return null;
    }
  }
}
